import { Box, BoxProps, Button, Text } from "@chakra-ui/react";

import { IcoExpandArrow } from "@/common/components/Icons";

export default function RowExpanderButton({
  isExpanded,
  onToggle,
  count,
  ...props
}: {
  isExpanded: boolean;
  onToggle: (e: React.MouseEvent<HTMLButtonElement>) => void;
  count?: number;
} & BoxProps) {
  return (
    <Box flex="0 0" {...props}>
      <Button
        aria-expanded={isExpanded}
        aria-label={`${count} more below`}
        color={isExpanded ? "dimmed" : undefined}
        colorScheme="gray"
        gap={1.5}
        rounded="full"
        size="2xs"
        title={`${isExpanded ? "Collapse" : "Expand"} subtree`}
        variant="outlineOnHover"
        onClick={onToggle}
      >
        <Text>{count}</Text>
        <IcoExpandArrow
          boxSize="7px"
          style={{
            transform: `rotate(${isExpanded ? 180 : 90}deg)`,
            transition: "transform 150ms ease-in-out",
          }}
        />
      </Button>
    </Box>
  );
}
